import { Button, Flex, Stack, TextInput } from "@mantine/core";
import { CloseOutlined, CodeOutlined, SearchOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { FC } from "react";
import {
    WebsiteLeadFilterButton,
    WebsiteLeadFilterPills
} from "./WebsiteLeadFilters";
import { WebsiteLeadFilterState } from "./useWebsiteLeadFilters";

type WebsiteLeadHeaderProps = {
    search: string;
    setSearch: (search: string) => void;
    filters: WebsiteLeadFilterState;
    setFilters: (filters: WebsiteLeadFilterState) => void;
    onOpenCodeModal: () => void;
};

export const WebsiteLeadHeader: FC<WebsiteLeadHeaderProps> = ({
    search,
    setSearch,
    filters,
    setFilters,
    onOpenCodeModal
}) => {
    return (
        <Stack gap="xs">
            <Flex justify="space-between" align="center">
                <Flex flex={1} gap="sm" align="center">
                    <TextInput
                        data-testid="search.bar.input"
                        placeholder="Search website leads..."
                        leftSection={<SvgIcon component={SearchOutlined} />}
                        value={search}
                        onChange={(e) => setSearch(e.currentTarget.value)}
                        rightSection={
                            search ? (
                                <SvgIcon
                                    component={CloseOutlined}
                                    sx={{
                                        width: "0.9rem",
                                        height: "0.9rem",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSearch("")}
                                />
                            ) : null
                        }
                    />
                    <WebsiteLeadFilterButton
                        filters={filters}
                        setFilters={setFilters}
                    />
                </Flex>
                <Flex flex={1} justify="flex-end">
                    <Button
                        leftSection={<SvgIcon component={CodeOutlined} />}
                        onClick={onOpenCodeModal}
                    >
                        Embedded Code
                    </Button>
                </Flex>
            </Flex>
            <WebsiteLeadFilterPills
                filters={filters}
                setFilters={setFilters}
            />
        </Stack>
    );
};
